const addressInfo = JSON.parse(localStorage.getItem('addressInfo'));
const form = document.getElementById('shipping-form');
const submitBtn = document.getElementById('confirmation-submit-btn');
const inputs = form.querySelectorAll('.trade-in-shipping__input');
const errorMessages = form.querySelectorAll('.trade-in-shipping__error p-small');
const firstNameLine = document.getElementById('first-name');
const lastNameLine = document.getElementById('last-name');
const emailLine = document.getElementById('email-address');
const addressLine1 = document.getElementById('address-1');
const addressLine2 = document.getElementById('address-2');
const cityLine = document.getElementById('city');
const stateSelector = document.getElementById('state-province');
const stateOptions = Array.from(stateSelector.querySelectorAll('option'));
const zipCodeLine = document.getElementById('zip-code');
const phoneLine = document.getElementById('phone');
const poBoxErrorMessage = form.querySelector('.poBoxMessage');
const poBoxErrorMessage2 = form.querySelector('.poBoxMessage2');
const militaryErrorMessage = form.querySelector('.militaryErrorMessage');

if (addressInfo) {
  firstNameLine.value = addressInfo.firstName;
  lastNameLine.value = addressInfo.lastName;
  emailLine.value = addressInfo.email;
  addressLine1.value = addressInfo.address1;
  addressLine2.value = addressInfo.address2;
  cityLine.value = addressInfo.city;
  const selectedOption = stateOptions.filter((x) => x.value === addressInfo.state);
  selectedOption[0]?.setAttribute('selected', 'selected');
  zipCodeLine.value = addressInfo.postalCode;
  phoneLine.value = addressInfo.phone;
  toggleSubmitButton();
}

const checkValidityFormInputs = () => {
  inputs.forEach(input => {
    toggleErrorMessage(input, true);
  })
}
// accessibility: when user submits form by pressing enter key
inputs.forEach(input => {
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      checkValidityFormInputs();
    }
  });
})

inputs.forEach(input => {
  input.addEventListener('blur', function () {
    toggleErrorMessage(input, true);
  });
})

form.addEventListener('input', function (e) {
  // Address validation modal lives in form, need to exclude from address validation input
  if (!e.target.className.includes('address-card-input')) {
    toggleErrorMessage(e.target);
    toggleSubmitButton();
  }
});

form.addEventListener('submit', async function (event) {
  event.preventDefault();
  toggleSubmitButton();

  if (form.checkValidity()) {
    const address = {
      address1: document.getElementById('address-1').value,
      address2: document.getElementById('address-2').value,
      city: document.getElementById('city').value,
      country: sessionStorage.getItem('tradeInCountry') === "Canada" ? "CA" : "US",
      email: document.getElementById('email-address').value,
      emailConsent: !!document.getElementById('checkbox-email').checked,
      firstName: document.getElementById('first-name').value,
      lastName: document.getElementById('last-name').value,
      // TODO: Add per-partner handling for these 2 fields (not needed for Goose)
      needsMitiKit: false,
      phone: document.getElementById('phone').value,
      postalCode: document.getElementById('zip-code').value,
      state: document.getElementById('state-province').value,
    };
    validate(address);
  }
});

function toggleErrorMessage(input, show = false) {
  // Validate PO box if allowpobox is false
  let hideGenericErrorMessage = false;
  if (form.getAttribute('allowpobox') === 'false') {
    if (input.id === 'address-1') {
      validatePoBox(input, poBoxErrorMessage);
      hideGenericErrorMessage = !poBoxErrorMessage.className.includes('hidden');
    }
    if (input.id === 'address-2') {
      validatePoBox(input, poBoxErrorMessage2);
      hideGenericErrorMessage = !poBoxErrorMessage.className.includes('hidden');
    }
  }

  // Validate Military address if allowmilitary is false
  if (form.getAttribute('allowmilitary') === 'false') {
    if (input.id === 'city') {
      validateMilitaryCity(input, militaryErrorMessage);
      hideGenericErrorMessage = !militaryErrorMessage.className.includes('hidden');
    }
  }

  const errorMessage = input.parentNode.lastElementChild;
  if (input.validity?.valid) {
    errorMessage.classList.add('hidden');
  } else if (show && !hideGenericErrorMessage) {
    errorMessage.classList.remove('hidden');
  }
  if (input.value) {
    input.classList.add('filled');
  } else if (show && isMilitaryErrorHidden) {
    input.classList.remove('filled');
  }
}

function toggleSubmitButton() {
  submitBtn.disabled = !form.checkValidity();
}

renderShippingCart();
